import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterForm({ source = "unknown", compact = false, testId = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim(), source });
      if (data.already_subscribed) {
        toast.success("You're already on the list — merci ✨");
      } else {
        toast.success("Welcome to the DaviDÉ list.");
      }
      setDone(true);
    } catch {
      toast.error("Couldn't subscribe. Try again.");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className={`inline-flex items-center gap-2 text-[var(--davide-gold)] ${compact ? "text-xs" : "text-sm"}`} data-testid={`${testId}-done`}>
        <Check size={14}/> You're in. Watch your inbox.
      </div>
    );
  }

  if (compact) {
    return (
      <form onSubmit={submit} className="flex gap-2" data-testid={`${testId}-form`}>
        <input type="email" required placeholder="you@email.com" value={email}
          data-testid={`${testId}-input`}
          onChange={(e)=>setEmail(e.target.value)}
          className="flex-1 bg-transparent border border-white/20 px-3 py-2 text-white text-sm focus:border-[var(--davide-gold)] outline-none transition-colors" />
        <button type="submit" disabled={loading}
          data-testid={`${testId}-submit`}
          className="bg-[var(--davide-gold)] text-black px-4 py-2 text-xs uppercase tracking-widest font-medium hover:bg-[var(--davide-gold-hover)] transition-colors">
          {loading ? "…" : "Join"}
        </button>
      </form>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-lg" data-testid={`${testId}-form`}>
      <div className="relative flex-1">
        <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
        <input type="email" required placeholder="your@email.com" value={email}
          data-testid={`${testId}-input`}
          onChange={(e)=>setEmail(e.target.value)}
          className="w-full bg-transparent border border-white/20 pl-11 pr-4 py-3.5 text-white focus:border-[var(--davide-gold)] outline-none transition-colors" />
      </div>
      <button type="submit" disabled={loading}
        data-testid={`${testId}-submit`}
        className="btn-gold">
        {loading ? "Joining…" : "Join the List"}
      </button>
    </form>
  );
}
